import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function createIRPF (payload) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getUploadFacturae.data)
    })
  } else {
    const req = {
      url: '/api/emisionfacturas/crearirpf',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: payload,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { createIRPF }
